module.exports = __webpack_public_path__ + "img/service-item-4.be9dca27.jpeg";